import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title", "aria-label", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "shrink-0",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = {
  key: 1,
  class: "shrink-0 ml-0.5 text-[10px] opacity-60 hover:opacity-100",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([
      'inline-flex items-center gap-1 max-w-[180px] truncate text-[11px] leading-none px-2 py-1 rounded-full border transition-colors',
      _ctx.kindClasses,
      _ctx.removable ? 'cursor-pointer hover:opacity-80' : 'cursor-default opacity-90'
    ]),
    title: _ctx.label,
    "aria-label": _ctx.label,
    disabled: !_ctx.removable,
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_ctx.iconForKind)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.iconForKind), 1))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1),
    (_ctx.removable)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "×"))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}